import { sendSpeakMessage } from '@utils/station';
import { useCallback } from 'react';
import { useStationMode } from '../station';

export const useGenerationMessageBridge = (
  sendMessage: (message: any) => void,
) => {
  const isStationMode = useStationMode();

  const sendMessageWithBridge = useCallback(
    (message: any) => {
      sendMessage(message);

      if (isStationMode && message.type === 'send_message') {
        const bridgeData = {
          ...message.data,
          trigger_response: message.data?.trigger_response ?? true,
        };
        sendSpeakMessage(bridgeData);
      }
    },
    [sendMessage, isStationMode],
  );

  return sendMessageWithBridge;
};
